import { API_SHIPPING_REQUEST_TAB_FILTER_SUMMARY } from "services/endpoints";
import { TAG_SHIPPING } from "services/tags";

export default (build) =>
	build.query({
		query: () => {
			return {
				url: API_SHIPPING_REQUEST_TAB_FILTER_SUMMARY,
				method: "GET"
			};
		},
		providesTags: [TAG_SHIPPING]
	});
